import React from 'react'

export const FormGroup = props => {
    const { children, required } = props;
    
    return (
        <div className={ "form-group" + (required ? ' required' : '') }>
            {children}
        </div>
    )
}

export default FormGroup;